var map = {
	"./Untitled design (1).png": 2474,
	"./Untitled design (2).png": 2363,
	"./Untitled design.png": 6568,
	"./hero_banner_mobile1.jpg": 5952,
	"./hero_banner_mobile2.jpg": 287
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1887;